<template>
  <create-view
    :loading="loading"
    :body-style="{ height: '100%'}">
    <flexbox
      direction="column"
      align="stretch"
      class="crm-create-container">
      <flexbox class="crm-create-header">
        <div style="flex:1;font-size:17px;color:#333;">{{ title }}</div>
        <img
          class="close"
          src="@/assets/img/task_close.png"
          @click="hidenView" >
      </flexbox>
      <div class="crm-create-flex">
        <create-sections title="基本資訊">
          <flexbox
            direction="column"
            align="stretch">
            <div class="crm-create-body">
              <el-form
                ref="crmForm"
                :model="crmForm"
                label-position="top"
                class="crm-create-box">
                <el-form-item
                  v-for="(item, index) in crmForm.crmFields"
                  :key="item.key"
                  :prop="'crmFields.' + index + '.value'"
                  :class="{ 'crm-create-block-item': item.showblock, 'crm-create-item': !item.showblock }"
                  :rules="crmRules[item.key]"
                  :style="{'padding-left': getPaddingLeft(item, index), 'padding-right': getPaddingRight(item, index)}">
                  <div
                    slot="label"
                    style="display: inline-block;">
                    <div style="margin:5px 0;font-size:12px;word-wrap:break-word;word-break:break-all;">
                      {{ item.data.name }}
                      <span style="color:#999;">
                        {{ item.data.input_tips ? '（'+item.data.input_tips+'）':'' }}
                      </span>
                    </div>
                  </div>
                  <!-- 員工 和部門 為多選（radio=false）  relation 相關合同商機使用-->
                  <component
                    :is="item.data.form_type | typeToComponentName"
                    :value="item.value"
                    :index="index"
                    :item="item"
                    :relation="item.relation"
                    :radio="false"
                    :types_id="action.id"
                    :disabled="item.disabled"
                    @value-change="fieldValueChange"/>
                </el-form-item>
              </el-form>
            </div>
          </flexbox>
        </create-sections>
        <create-sections
          v-if="showExamine"
          title="審覈資訊">
          <div
            v-if="examineInfo.config===1 || examineInfo.config===0"
            slot="header"
            class="examine-type">{{ examineInfo.config===1 ? '固定審批流' : '授權審批人' }}</div>
          <create-examine-info
            ref="examineInfo"
            :types="'crm_' + crmType"
            :types_id="action.id"
            @value-change="examineValueChange"/>
        </create-sections>
      </div>

      <div class="handle-bar">
        <el-button
          class="handle-button"
          @click.native="hidenView">取消</el-button>
        <el-button
          v-if="crmType=='customer' && action.type == 'save'"
          class="handle-button"
          type="primary"
          @click.native="saveField(true)">儲存並新建聯繫人</el-button>
        <el-button
          v-if="showDraft"
          class="handle-button"
          type="primary"
          plain
          @click.native="saveDraftField()">儲存草稿</el-button>
        <el-button
          class="handle-button"
          type="primary"
          @click.native="saveField(false)">{{ sureBtnTitle }}</el-button>
      </div>
    </flexbox>
  </create-view>
</template>
<script type="text/javascript">
import CreateView from '@/components/CreateView'
import CreateSections from '@/components/CreateSections'
import CreateExamineInfo from '@/components/Examine/CreateExamineInfo'
import { filedGetField, filedValidates } from '@/api/customermanagement/common'
import { crmLeadsSave, crmLeadsUpdate } from '@/api/customermanagement/clue'
import {
  crmCustomerSave,
  crmCustomerUpdate
} from '@/api/customermanagement/customer'
import {
  crmContactsSave,
  crmContactsUpdate
} from '@/api/customermanagement/contacts'
import {
  crmBusinessSave,
  crmBusinessUpdate,
  crmBusinessProduct // 商機下產品
} from '@/api/customermanagement/business'
import {
  crmContractSave,
  crmContractUpdate
} from '@/api/customermanagement/contract'
import {
  crmProductSave,
  crmProductUpdate
} from '@/api/customermanagement/product'
import {
  crmReceivablesSave,
  crmReceivablesUpdate
} from '@/api/customermanagement/money'
import {
  crmReceivablesPlanSave,
  crmReceivablesPlanUpdate
} from '@/api/customermanagement/contract'

import {
  regexIsCRMNumber,
  regexIsCRMMoneyNumber,
  regexIsCRMMobile,
  regexIsCRMEmail,
  formatTimeToTimestamp,
  timestampToFormatTime
} from '@/utils'
import { isArray } from '@/utils/types'

import {
  XhInput,
  XhTextarea,
  XhSelect,
  XhMultipleSelect,
  XhDate,
  XhDateTime,
  XhUserCell,
  XhStructureCell,
  XhFiles,
  CrmRelativeCell,
  XhProuctCate,
  XhProduct,
  XhBusinessStatus,
  XhCustomerAddress,
  XhReceivablesPlan // 回款計劃期數
} from '@/components/CreateCom'

export default {
  name: 'CrmCreateView', // 所有新建效果的view
  components: {
    CreateView,
    CreateSections,
    CreateExamineInfo, // 審覈資訊
    XhInput,
    XhTextarea,
    XhSelect,
    XhMultipleSelect,
    XhDate,
    XhDateTime,
    XhUserCell,
    XhStructureCell,
    XhFiles,
    CrmRelativeCell,
    XhProuctCate,
    XhProduct,
    XhBusinessStatus,
    XhCustomerAddress,
    XhReceivablesPlan
  },
  filters: {
    /** 根據type 找到元件 */
    typeToComponentName(form_type) {
      if (
        form_type == 'text' ||
        form_type == 'number' ||
        form_type == 'floatnumber' ||
        form_type == 'mobile' ||
        form_type == 'email'
      ) {
        return 'XhInput'
      } else if (form_type == 'textarea') {
        return 'XhTextarea'
      } else if (form_type == 'select' || form_type == 'business_status') {
        return 'XhSelect'
      } else if (form_type == 'checkbox') {
        return 'XhMultipleSelect'
      } else if (form_type == 'date') {
        return 'XhDate'
      } else if (form_type == 'datetime') {
        return 'XhDateTime'
      } else if (form_type == 'user') {
        return 'XhUserCell'
      } else if (form_type == 'structure') {
        return 'XhStructureCell'
      } else if (form_type == 'file') {
        return 'XhFiles'
      } else if (
        form_type == 'contacts' ||
        form_type == 'customer' ||
        form_type == 'contract' ||
        form_type == 'business'
      ) {
        return 'CrmRelativeCell'
      } else if (form_type == 'category') {
        // 產品類別
        return 'XhProuctCate'
      } else if (form_type == 'business_type') {
        // 商機類別
        return 'XhBusinessStatus'
      } else if (form_type == 'product') {
        return 'XhProduct'
      } else if (form_type == 'map_address') {
        return 'XhCustomerAddress'
      } else if (form_type == 'receivables_plan') {
        return 'XhReceivablesPlan'
      }
    }
  },
  props: {
    // CRM型別
    crmType: {
      type: String,
      default: ''
    },
    /**
     * save:新增、update:編輯(action_id)、read:詳情、index:列表
     * relative: 相關 新增(目前用於客戶等相關新增)
     */
    action: {
      type: Object,
      default: () => {
        return {
          type: 'save',
          id: ''
        }
      }
    }
  },
  data() {
    return {
      // 標題展示名稱
      title: '',
      loading: false,
      saveAndCreate: false, // 儲存並新建
      // 自定義欄位驗證規則
      crmRules: {},
      // 自定義欄位資訊表單
      crmForm: {
        crmFields: []
      },
      // 審批資訊
      examineInfo: {}
    }
  },
  computed: {
    /** 合同 回款 下展示審批人資訊 */
    showExamine() {
      if (this.crmType === 'contract' || this.crmType === 'receivables') {
        return true
      }
      return false
    },
    // 草稿按鈕
    showDraft() {
      if (this.crmType === 'contract' || this.crmType === 'receivables') {
        return true
      }
      return false
    },
    sureBtnTitle() {
      if (this.crmType === 'contract' || this.crmType === 'receivables') {
        return '提交審覈'
      }
      return '儲存'
    }
  },
  watch: {
    crmType: function(value) {
      this.title = this.getTitle()
      this.crmRules = {}
      this.crmForm = {
        crmFields: []
      }
      this.examineInfo = {}
      this.getField()
    }
  },
  mounted() {
    // 獲取title展示名稱
    document.body.appendChild(this.$el)
    this.title = this.getTitle()
    this.getField()
  },
  destroyed() {
    // remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  methods: {
    // 審批資訊值更新
    examineValueChange(data) {
      this.examineInfo = data
    },
    // 欄位的值更新
    fieldValueChange(data) {
      var item = this.crmForm.crmFields[data.index]
      item.value = data.value
      // 商機下處理商機狀態
      if (
        this.crmType == 'business' &&
        item.data.form_type == 'business_type'
      ) {
        // 找到階段數據
        for (
          let statusIndex = 0;
          statusIndex < this.crmForm.crmFields.length;
          statusIndex++
        ) {
          const statusElement = this.crmForm.crmFields[statusIndex]
          if (statusElement.data.form_type == 'business_status') {
            for (let typeIndex = 0; typeIndex < data.data.length; typeIndex++) {
              const typeElement = data.data[typeIndex]
              if (typeElement.type_id == data.value) {
                statusElement.data.setting = typeElement.statusList.map(
                  function(item, index) {
                    item['value'] = item.status_id
                    return item
                  }
                )
                statusElement.value = ''
                this.$set(this.crmForm.crmFields, statusIndex, statusElement)
                break
              }
            }
          }
        }
      } else if (this.crmType == 'contract') {
        if (item.data.form_type == 'customer') {
          // 新建合同 選擇客戶 要將id交於 商機
          for (let index = 0; index < this.crmForm.crmFields.length; index++) {
            const element = this.crmForm.crmFields[index]
            if (element.key === 'business_id') {
              // 如果是商機 改變商機樣式和傳入客戶ID
              if (item.value.length > 0) {
                element.disabled = false
                var customerItem = item.value[0]
                customerItem['form_type'] = 'customer'
                element['relation'] = customerItem
              } else {
                element.disabled = true
                element['relation'] = {}
                element.value = []
              }
              break
            }
          }
        } else if (item.data.form_type == 'business') {
          if (item.value.length > 0) {
            crmBusinessProduct({
              business_id: item.value[0].business_id
            })
              .then(res => {
                for (
                  let index = 0;
                  index < this.crmForm.crmFields.length;
                  index++
                ) {
                  const element = this.crmForm.crmFields[index]
                  if (element.key === 'product') {
                    element['value'] = {
                      product: res.data.list,
                      total_price: res.data.total_price,
                      discount_rate: res.data.discount_rate
                    }
                    break
                  }
                }
              })
              .catch(() => {})
          }
        }
      } else if (this.crmType == 'receivables') {
        // 新建回款 選擇客戶 要將id交於 合同
        if (item.data.form_type == 'customer') {
          var planItem = null // 合同更改 重置回款計劃
          for (let index = 0; index < this.crmForm.crmFields.length; index++) {
            const element = this.crmForm.crmFields[index]
            if (element.key === 'contract_id') {
              // 如果是合同 改變合同樣式和傳入客戶ID
              if (item.value.length > 0) {
                element.disabled = false
                var customerItem = item.value[0]
                customerItem['form_type'] = 'customer'
                customerItem['params'] = { check_status: 2 }
                element['relation'] = customerItem
              } else {
                element.disabled = true
                element['relation'] = {}
                element.value = []
              }
            } else if (element.key === 'plan_id') {
              planItem = element
            }
          }
          if (planItem) {
            planItem.disabled = true
            planItem['relation'] = {}
            planItem.value = ''
          }
        } else if (item.data.form_type == 'contract') {
          for (let index = 0; index < this.crmForm.crmFields.length; index++) {
            const element = this.crmForm.crmFields[index]
            if (element.key === 'plan_id') {
              // 如果是回款 改變回款樣式和傳入客戶ID
              if (item.value.length > 0) {
                element.disabled = false
                var contractItem = item.value[0]
                contractItem['form_type'] = 'contract'
                element['relation'] = contractItem
              } else {
                element.disabled = true
                element['relation'] = {}
                element.value = ''
              }
              break
            }
          }
        } else if (item.data.form_type == 'receivables_plan') {
          this.crmForm.crmFields.forEach(item => {
            if (item.key == 'return_time') {
              item.value = data.plan.return_date
            } else if (item.key == 'return_type') {
              item.value = data.plan.return_type
            } else if (item.key == 'money') {
              item.value = data.plan.money
            }
          })
        }
      }

      // 無事件的處理 後期可換成input實現
      if (
        item.data.form_type == 'user' ||
        item.data.form_type == 'structure' ||
        item.data.form_type == 'file' ||
        item.data.form_type == 'category' ||
        item.data.form_type == 'customer' ||
        item.data.form_type == 'business' ||
        item.data.form_type == 'contract'
      ) {
        this.$refs.crmForm.validateField('crmFields.' + data.index + '.value')
      }
    },
    // 獲取自定義欄位
    getField() {
      this.loading = true
      // 獲取自定義欄位的更新時間
      var params = {}
      params.types = 'crm_' + this.crmType
      params.module = 'crm'
      params.controller = this.crmType
      params.action =
        this.action.type === 'relative' ? 'save' : this.action.type
      // 進行編輯操作
      if (this.action.type == 'update') {
        params.action_id = this.action.id
      }

      filedGetField(params)
        .then(res => {
          this.getcrmRulesAndModel(res.data)
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 根據自定義欄位獲取自定義欄位規則
    getcrmRulesAndModel(list) {
      let showStyleIndex = -1
      for (let index = 0; index < list.length; index++) {
        const item = list[index]
        showStyleIndex += 1
        /**
         * 規則數據
         */

        this.crmRules[item.field] = this.getItemRulesArrayFromItem(item)

        /**
         * 表單數據
         */
        if (
          // crm相關資訊特殊處理
          item.form_type == 'contacts' ||
          item.form_type == 'customer' ||
          item.form_type == 'contract' ||
          item.form_type == 'business' ||
          item.form_type == 'receivables_plan'
        ) {
          var params = {}
          params['key'] = item.field
          params['data'] = item
          // 獲取 value relative 資訊
          this.getParamsValueAndRelativeInfo(params, item, list)
          params['disabled'] = this.getItemDisabledFromItem(item)
          params['styleIndex'] = showStyleIndex
          this.crmForm.crmFields.push(params)
        } else if (item.form_type == 'category') {
          /** 產品分類 */
          var params = {}
          params['key'] = item.field
          params['data'] = item
          if (this.action.type == 'update' && item.value) {
            params['value'] = item.value
              ? item.value.map(function(item, index, array) {
                return parseInt(item)
              })
              : []
          } else {
            params['value'] = []
          }
          params['disabled'] = false // 是否可互動
          params['styleIndex'] = showStyleIndex
          this.crmForm.crmFields.push(params)
        } else if (item.form_type == 'product') {
          // 關聯產品資訊比較多 用字典接收
          var params = {}
          params['value'] = item.value
          params['key'] = item.field
          params['data'] = item
          params['disabled'] = false // 是否可互動
          params['showblock'] = true // 展示整行效果
          if (index % 2 == 0) {
            showStyleIndex = -1
          }
          this.crmForm.crmFields.push(params)
        } else if (item.form_type == 'map_address') {
          // 關聯產品資訊比較多 用字典接收
          var params = {}

          if (this.action.type == 'update') {
            params['value'] = item.value // 編輯的值 在value欄位
          } else {
            params['value'] = {} // 加入預設值 可能編輯的時候需要調整
          }
          params['key'] = item.field
          params['data'] = item
          params['disabled'] = false // 是否可互動
          params['showblock'] = true // 展示整行效果
          if (index % 2 == 0) {
            showStyleIndex = -1
          }
          this.crmForm.crmFields.push(params)
        } else if (item.form_type == 'datetime') {
          // 返回的時間戳  要處理為格式化時間（編輯的時候）
          // 關聯產品資訊比較多 用字典接收
          var params = {}

          if (this.action.type == 'update') {
            params['value'] =
              item.value && item.value !== 0
                ? timestampToFormatTime(item.value, 'YYYY-MM-DD HH:mm:ss')
                : '' // 編輯的值 在value欄位
          } else {
            params['value'] = item.default_value // 加入預設值 可能編輯的時候需要調整
          }

          params['key'] = item.field
          params['data'] = item
          params['disabled'] = false // 是否可互動
          params['styleIndex'] = showStyleIndex
          this.crmForm.crmFields.push(params)
        } else {
          var params = {}
          if (this.action.type == 'update') {
            params['value'] = item.value // 編輯的值 在value欄位
          } else {
            params['value'] = item.default_value
              ? item.default_value
              : item.value // 加入預設值 可能編輯的時候需要調整
          }
          params['key'] = item.field
          params['data'] = item
          params['disabled'] = false // 是否可互動
          params['styleIndex'] = showStyleIndex
          this.crmForm.crmFields.push(params)
        }
      }
    },
    /**
     * 獲取關聯項的值 和 關聯資訊
     */
    getParamsValueAndRelativeInfo(params, item, list) {
      if (this.action.type == 'relative') {
        const relativeData = this.action.data[item.form_type]
        if (item.form_type == 'receivables_plan') {
          params['value'] = ''
        } else {
          params['value'] = relativeData ? [relativeData] : []
        }
      } else {
        params['value'] = item.value
      }
      if (this.action.type == 'relative' || this.action.type == 'update') {
        // 回款計劃 需要合同資訊
        if (item.form_type === 'receivables_plan') {
          const contractItem = this.getItemRelatveInfo(item, list, 'contract')
          if (contractItem) {
            contractItem['form_type'] = 'contract'
            params['relation'] = contractItem
          }
          // 商機合同 需要客戶資訊
        } else if (
          item.form_type == 'business' ||
          item.form_type == 'contract'
        ) {
          const customerItem = this.getItemRelatveInfo(item, list, 'customer')
          if (item.form_type == 'business' && customerItem) {
            customerItem['form_type'] = 'customer'
            params['relation'] = customerItem
          } else if (item.form_type == 'contract' && customerItem) {
            customerItem['form_type'] = 'customer'
            customerItem['params'] = { check_status: 2 }
            params['relation'] = customerItem
          }
        }
      }
    },
    /**
     * 獲取相關聯item
     */
    getItemRelatveInfo(item, list, from_type) {
      let crmItem = null
      if (this.action.type == 'relative') {
        crmItem = this.action.data[from_type]
      } else {
        const crmObj = list.find(listItem => {
          return listItem.form_type === from_type
        })
        if (crmObj && crmObj.value && crmObj.value.length > 0) {
          crmItem = crmObj.value[0]
        }
      }
      return crmItem
    },
    /**
     * 獲取關聯項是否可操作
     */
    getItemDisabledFromItem(item) {
      // 相關新增
      if (this.action.type == 'relative') {
        const relativeDisInfos = {
          business: {
            customer: { customer: true },
            contacts: { customer: true }
          },
          contacts: {
            customer: { customer: true }
          },
          contract: {
            customer: { customer: true },
            business: { customer: true, business: true }
          },
          receivables_plan: {
            contract: { customer: true, contract: true },
            customer: { customer: true }
          },
          receivables: {
            contract: { customer: true, contract: true },
            customer: { customer: true }
          }
        }
        // 新增型別
        const crmTypeDisInfos = relativeDisInfos[this.crmType]
        if (crmTypeDisInfos) {
          // 在哪個型別下新增
          const relativeTypeDisInfos = crmTypeDisInfos[this.action.crmType]
          if (relativeTypeDisInfos) {
            // 包含的欄位值
            return relativeTypeDisInfos[item.form_type] || false
          }
        }
        return false
      } else if (this.action.type != 'update') {
        // 新建
        if (this.crmType === 'contract' && item.form_type === 'business') {
          return true
          // 回款下 新建 合同 和 回款計劃 預設不能操作
        } else if (this.crmType === 'receivables') {
          if (item.form_type === 'contract') {
            return true
          } else if (item.form_type === 'receivables_plan') {
            return true
          }
        }
      }
      return false
    },
    /**
     * item 當行數據源
     */
    getItemRulesArrayFromItem(item) {
      var tempList = []

      // 驗證必填
      if (item.is_null == 1) {
        if (item.form_type == 'category') {
          tempList.push({
            required: true,
            message: item.name + '不能為空',
            trigger: []
          })
        } else {
          tempList.push({
            required: true,
            message: item.name + '不能為空',
            trigger: ['blur', 'change']
          })
        }
      }

      // 驗證唯一
      if (item.is_unique == 1) {
        var validateUnique = (rule, value, callback) => {
          if ((isArray(value) && value.length == 0) || !value) {
            callback()
          } else {
            var validatesParams = {}
            validatesParams.field = rule.item.field
            validatesParams.val = value
            validatesParams.types = 'crm_' + this.crmType
            if (this.action.type == 'update') {
              validatesParams.id = this.action.id
            }
            filedValidates(validatesParams)
              .then(res => {
                callback()
              })
              .catch(error => {
                callback(new Error(error.error ? error.error : '驗證出錯'))
              })
          }
        }
        tempList.push({
          validator: validateUnique,
          item: item,
          trigger:
            item.form_type == 'checkbox' || item.form_type == 'select'
              ? ['change']
              : ['blur']
        })
      }

      // 特殊字元
      if (item.form_type == 'number') {
        var validateCRMNumber = (rule, value, callback) => {
          if (!value || value == '' || regexIsCRMNumber(value)) {
            callback()
          } else {
            callback(new Error('數字的整數部分須少於12位，小數部分須少於4位'))
          }
        }
        tempList.push({
          validator: validateCRMNumber,
          item: item,
          trigger: ['blur']
        })
      } else if (item.form_type == 'floatnumber') {
        var validateCRMMoneyNumber = (rule, value, callback) => {
          if (!value || value == '' || regexIsCRMMoneyNumber(value)) {
            callback()
          } else {
            callback(new Error('貨幣的整數部分須少於10位，小數部分須少於2位'))
          }
        }
        tempList.push({
          validator: validateCRMMoneyNumber,
          item: item,
          trigger: ['blur']
        })
      } else if (item.form_type == 'mobile') {
        var validateCRMMobile = (rule, value, callback) => {
          if (!value || value == '' || regexIsCRMMobile(value)) {
            callback()
          } else {
            callback(new Error('手機格式有誤'))
          }
        }
        tempList.push({
          validator: validateCRMMobile,
          item: item,
          trigger: ['blur']
        })
      } else if (item.form_type == 'email') {
        var validateCRMEmail = (rule, value, callback) => {
          if (!value || value == '' || regexIsCRMEmail(value)) {
            callback()
          } else {
            callback(new Error('郵箱格式有誤'))
          }
        }
        tempList.push({
          validator: validateCRMEmail,
          item: item,
          trigger: ['blur']
        })
      }
      return tempList
    },
    // 儲存草稿
    saveDraftField() {
      this.saveField(false, true)
    },
    // 儲存數據
    saveField(saveAndCreate, isDraft = false) {
      this.saveAndCreate = saveAndCreate
      this.$refs.crmForm.validate(valid => {
        if (valid) {
          if (this.showExamine) {
            /** 驗證審批數據 */
            if (isDraft) {
              // 不驗證數據
              var params = this.getSubmiteParams(this.crmForm.crmFields)
              if (
                this.examineInfo.config === 0 &&
                this.examineInfo.hasOwnProperty('value') &&
                this.examineInfo.value.length
              ) {
                params['check_user_id'] = this.examineInfo.value[0].id
              }
              params.is_draft = 1
              this.submiteParams(params)
            } else {
              this.$refs.examineInfo.validateField(() => {
                var params = this.getSubmiteParams(this.crmForm.crmFields)
                if (this.examineInfo.config === 0) {
                  params['check_user_id'] = this.examineInfo.value[0].id
                }
                this.submiteParams(params)
              })
            }
          } else {
            var params = this.getSubmiteParams(this.crmForm.crmFields)
            this.submiteParams(params)
          }
        } else {
          return false
        }
      })
    },
    /** 上傳 */
    submiteParams(params) {
      this.loading = true
      var crmRequest = this.getSubmiteRequest()
      if (this.action.type == 'update') {
        params.id = this.action.id
      }
      crmRequest(params)
        .then(res => {
          this.loading = false
          if (this.crmType == 'customer') {
            if (!this.saveAndCreate) {
              this.$message.success(
                this.action.type == 'update' ? '編輯成功' : '新增成功'
              )
              this.hidenView()
            }
          } else {
            this.hidenView()
            this.$message.success(res.data)
          }
          // 回到儲存成功
          this.$emit('save-success', {
            type: this.crmType,
            data: res.data,
            saveAndCreate: this.saveAndCreate
          })
        })
        .catch(() => {
          this.loading = false
        })
    },
    /** 獲取上傳url */
    getSubmiteRequest() {
      if (this.crmType == 'leads') {
        return this.action.type == 'update' ? crmLeadsUpdate : crmLeadsSave
      } else if (this.crmType == 'customer') {
        return this.action.type == 'update'
          ? crmCustomerUpdate
          : crmCustomerSave
      } else if (this.crmType == 'contacts') {
        return this.action.type == 'update'
          ? crmContactsUpdate
          : crmContactsSave
      } else if (this.crmType == 'business') {
        return this.action.type == 'update'
          ? crmBusinessUpdate
          : crmBusinessSave
      } else if (this.crmType == 'product') {
        return this.action.type == 'update' ? crmProductUpdate : crmProductSave
      } else if (this.crmType == 'contract') {
        return this.action.type == 'update'
          ? crmContractUpdate
          : crmContractSave
      } else if (this.crmType == 'receivables') {
        return this.action.type == 'update'
          ? crmReceivablesUpdate
          : crmReceivablesSave
      } else if (this.crmType == 'receivables_plan') {
        return this.action.type == 'update'
          ? crmReceivablesPlanUpdate
          : crmReceivablesPlanSave
      }
    },
    /** 拼接上傳傳輸 */
    getSubmiteParams(array) {
      var params = {}
      for (let index = 0; index < array.length; index++) {
        const element = array[index]
        // 關聯產品數據需要特殊拼接
        if (element.key == 'product') {
          this.getProductParams(params, element)
        } else if (element.key == 'customer_address') {
          // 位置資訊需要注入多個欄位
          this.getCustomerAddressParams(params, element)
        } else {
          const value = this.getRealParams(element)
          if (!(element.data.form_type == 'date' && !value)) {
            params[element.key] = value
          }
        }
      }
      return params
    },
    getProductParams(params, element) {
      params['product'] = element.value.product
      params['total_price'] = element.value.total_price
        ? element.value.total_price
        : 0
      params['discount_rate'] = element.value.discount_rate
        ? element.value.discount_rate
        : 0
    },
    // 獲取客戶位置參數
    getCustomerAddressParams(params, element) {
      params['address'] = element.value.address
      params['detail_address'] = element.value.detail_address
      params['location'] = element.value.location
      params['lng'] = element.value.lng
      params['lat'] = element.value.lat
    },
    // 關聯客戶 聯繫人等數據要特殊處理
    getRealParams(element) {
      if (
        element.key == 'customer_id' ||
        element.key == 'contacts_id' ||
        element.key == 'business_id' ||
        element.key == 'leads_id' ||
        element.key == 'contract_id'
      ) {
        if (element.value.length) {
          return element.value[0][element.key]
        } else {
          return ''
        }
      } else if (
        element.data.form_type == 'user' ||
        element.data.form_type == 'structure'
      ) {
        return element.value.map(function(item, index, array) {
          return item.id
        })
      } else if (element.data.form_type == 'file') {
        return element.value.map(function(item, index, array) {
          return item.file_id
        })
      } else if (element.data.form_type == 'datetime') {
        // datetime 時間戳 date 格式化時間
        return element.value
          ? formatTimeToTimestamp(element.value)
          : element.value
      }

      return element.value
    },
    hidenView() {
      this.$emit('hiden-view')
    },
    // 根據型別獲取標題展示名稱
    getTitle() {
      if (this.crmType == 'leads') {
        return this.action.type == 'update' ? '編輯線索' : '新建線索'
      } else if (this.crmType == 'customer') {
        return this.action.type == 'update' ? '編輯客戶' : '新建客戶'
      } else if (this.crmType == 'contacts') {
        return this.action.type == 'update' ? '編輯聯繫人' : '新建聯繫人'
      } else if (this.crmType == 'business') {
        return this.action.type == 'update' ? '編輯商機' : '新建商機'
      } else if (this.crmType == 'product') {
        return this.action.type == 'update' ? '編輯產品' : '新建產品'
      } else if (this.crmType == 'contract') {
        return this.action.type == 'update' ? '編輯合同' : '新建合同'
      } else if (this.crmType == 'receivables') {
        return this.action.type == 'update' ? '編輯回款' : '新建回款'
      } else if (this.crmType == 'receivables_plan') {
        return this.action.type == 'update' ? '編輯回款計劃' : '新建回款計劃'
      }
    },
    // 獲取左邊padding
    getPaddingLeft(item, index) {
      if (item.showblock && item.showblock == true) {
        return '0'
      }
      return item.styleIndex % 2 == 0 ? '0' : '25px'
    },
    // 獲取左邊padding
    getPaddingRight(item, index) {
      if (item.showblock && item.showblock == true) {
        return '0'
      }

      return item.styleIndex % 2 == 0 ? '25px' : '0'
    }
  }
}
</script>
<style lang="scss" scoped>
.crm-create-container {
  position: relative;
  height: 100%;
}

.crm-create-flex {
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1;
}

.crm-create-header {
  height: 40px;
  margin-bottom: 20px;
  padding: 0 10px;
  flex-shrink: 0;
  .close {
    display: block;
    width: 40px;
    height: 40px;
    margin-right: -10px;
    padding: 10px;
    cursor: pointer;
  }
}

.crm-create-body {
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
}

/** 將其改變為flex佈局 */
.crm-create-box {
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px;
}

.crm-create-item {
  flex: 0 0 50%;
  flex-shrink: 0;
  // overflow: hidden;
  padding-bottom: 10px;
}

// 佔用一整行
.crm-create-block-item {
  flex: 0 0 100%;
  flex-shrink: 0;
  padding-bottom: 10px;
}

.el-form-item::v-deep.el-form-item__label {
  line-height: normal;
  font-size: 13px;
  color: #333333;
  position: relative;
  padding-left: 8px;
  padding-bottom: 0;
}

.el-form::v-deep.el-form-item {
  margin-bottom: 0px;
}

.el-form::v-deep.el-form-item.is-required .el-form-item__label:before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
  position: absolute;
  left: 0;
  top: 5px;
}

.handle-bar {
  position: relative;
  .handle-button {
    float: right;
    margin-top: 5px;
    margin-right: 20px;
  }
}

.el-button + .el-button {
  margin-left: 0;
}

// 審覈資訊 里的審覈型別
.examine-type {
  font-size: 12px;
  color: white;
  background-color: #fd715a;
  padding: 0 8px;
  margin-left: 5px;
  height: 16px;
  line-height: 16px;
  border-radius: 8px;
  transform: scale(0.8, 0.8);
}
</style>
